import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { theme } from '../constants/theme';
import { ArrowLeft } from '../../assets/icons';
import { StackNavigationProp } from '@react-navigation/stack';

type BackButtonProps = {
  navigation: { goBack: () => void };
  size?: number;
};

const BackButton: React.FC<BackButtonProps> = ({ navigation, size = 26 }) => {
  return (
    <Pressable onPress={() => navigation.goBack()} style={styles.button}>
      <ArrowLeft
        strokeWidth={2.5}
        width={size}
        height={size}
        color={theme.colors.text}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    alignSelf: 'flex-start',
    padding: 5,
    borderRadius: theme.radius.sm,
    backgroundColor: 'rgba(0,0,0,0.07)',
  },
});

export default BackButton;
